
import React from 'react';
import { Button } from '@/components/ui/button';
import { Check, Loader2 } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface SubmitButtonProps {
  isSubmitting: boolean;
  isSuccess: boolean;
  isError: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ isSubmitting, isSuccess, isError }) => {
  const isMobile = useIsMobile();

  // Determine button color class based on state
  const getButtonColorClass = () => {
    if (isSuccess) return "bg-green-500 hover:bg-green-600 text-white border-green-500";
    if (isError) return "bg-red-500 hover:bg-red-600 text-white border-red-500";
    return "bg-transparent border border-elegant-200 hover:bg-elegant-100/50 text-elegant-900";
  };

  return (
    <div className="flex justify-center mt-4">
      <Button 
        type="submit" 
        className={`${isMobile ? 'w-full text-sm py-1.5' : 'w-1/3 py-2'} transition-all duration-300 ${getButtonColorClass()}`}
        disabled={isSubmitting || isSuccess}
      >
        {isSubmitting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Wysyłanie...
          </>
        ) : isSuccess ? (
          <>
            <Check className="mr-2 h-4 w-4" />
            Wysłano pomyślnie
          </>
        ) : (
          'Wyślij zapytanie'
        )}
      </Button>
    </div>
  );
};

export default SubmitButton;
